<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="is-size-1">このページにアクセスする権限がありません</div>
        <div>
          <router-link to="/" class="button">トップへ戻る</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {

}
</script>